<template>
  <div class="px-[20px] pt-[10px] pb-[20px] bg-white rounded-sm">
    <CruiseDetailCommenTitle title="航次行程" />
    <el-table :class="$style.table" stripe :data="voyages" style="width: 100%;">
      <el-table-column align="left" type="expand" width="50">
        <template slot-scope="scope">
          <div class="pl-[160px] bg-[#F7F8FC]">
            <el-table :class="$style.table__inner" stripe :data="scope.row.product_tours" style="width: 100%">
              <el-table-column prop="date" label="日期" width="180">
              </el-table-column>
              <el-table-column prop="name" label="港口">
                <template slot-scope="scopeInner">
                  <div class="flex">
                    <span class="ficon ficon-xingzhuangjiehe1 mr-[10px]"></span>
                    <ul>
                      <li v-for="(port_data, portDataIndex) in scopeInner.row.port_data" :key="portDataIndex">
                        <el-image v-if="port_data.flag" class="mr-[10px]" style="width: 18px" :src="port_data.flag" lazy>
                        </el-image>
                        <!-- <span>{{port_data.city_name }}</span> -->
                        <span>{{ port_data.port }}</span>
                      </li>
                    </ul>
                    <span class="ml-[10px]">
                      {{ scopeInner.$index == 0 ? '出发' : '' }}
                      {{ scopeInner.$index == scope.row.product_tours.length - 1 && scope.row.product_tours.length > 1 ?
                          '结束' : ''
                      }}
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="left" label="日期" prop="date" width="130"></el-table-column>
      <el-table-column align="left" label="产品名称" prop="name"></el-table-column>
      <el-table-column align="left" label="港口" prop="port" width="200" #default="{ row }">
        <div class="flex items-center">
          <div style="width: 18px;" class="mr-[5px]">
            <el-image v-if="row.flag" class="mr-[10px]" style="width: 18px;" :src="row.flag" lazy></el-image>
          </div>
          <span class="flex-1 overflow-auto text-xs">{{ row.port }}</span>
        </div>
      </el-table-column>
      <el-table-column align="left" label="价格" prop="price" width="220" #default="{ row }">
        ￥{{ row.price }}起
        <el-button type="primary" round size="small" class="mr-[24px] !pl-[15px] !pr-[15px] float-right"
          @click="onBookingCruise(row)">预订</el-button>
      </el-table-column>
    </el-table>
    <div class="flex items-center justify-center py-[10px] cursor-pointer"
      v-if="all_voyage.length > 10 && voyages.length <= 10" @click="showAllVoyage">
      <span>查看更多</span>
      <i class="ficon ficon-arrow-bottom ml-[10px]"></i>
    </div>
  </div>
</template>

<script>
import CruiseDetailCommenTitle from "@/views/company/CruiseDetailCommenTitle.vue"
import PopoverRouteDetail from "~/views/cruise-map/popover-route-detail.vue";
import { isEmpty } from "lodash";
import { ProductTypes } from "@/constants/productType.js";
import { productDetailLink } from "@/utils/product";


export default {
  name: "RouteDetail",
  components: {
    CruiseDetailCommenTitle,
    PopoverRouteDetail,
  },
  props: {
    all_voyage: {
      type: Array,
      default: () => []
    },
    productType: {
      type: String,
      default: ProductTypes.CRUISE,
    },
  },
  data() {
    return {
      voyages: []
    }
  },
  mounted() {
    this.voyages = this.all_voyage.slice(0, 10)
  },
  methods: {
    isEmpty,
    onBookingCruise(row) {
      window.open(row.is_tripartite_product > 0 ? `/product/automation/${row.product_no}` : productDetailLink(this.productType, row.product_no),'_blank')
    },
    showAllVoyage() {
      this.voyages = this.all_voyage.slice()
    }
  },
};
</script>
<style lang="scss" module>

.table {
  :global(.el-table__header-wrapper) {
    border-radius: 2px !important;

    * {
      color: #000000 !important;
      background-color: #F2F4FA !important;
    }
  }

  :global(tr.el-table__row--striped td.el-table__cell) {
    background-color: #F7F8FC;
  }

  :global(.el-table__cell.el-table__expanded-cell) {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  :global(.el-table__row.el-table__row--striped.expanded td) {
    border-bottom: none !important;
  }

  :global(.el-table__row.expanded) {
    background-color: #F7F8FC !important;
    color: #000;
  }

  :global(.el-table__row.expanded td:nth-child(3)) {
    font-weight: 500 !important;
  }

  // 展开table
  &__inner {
    background-color: #F7F8FC;

    :global(.el-table__header-wrapper) {
      border-radius: 0 !important;

      * {
        color: #000 !important;
        background-color: #E9EDF8 !important;
        border: none !important;
      }
    }

    // :global(.el-table__row--striped),
    // :global(.el-table__row--striped *) {
    //   background-color: #F7F8FC !important;
    // }


    // :global(.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell) {
    :global(tr),
    :global(td.el-table__cell) {
      background-color: transparent !important;
    }
  }

  :global(.el-table__expand-icon i) {
    transform: rotate(90deg);
    transform-origin: center;
  }

  :global(.el-table__expand-icon i::before) {
    font-family: "iconfont" !important;
    // element-icons!important
    content: "\e6b9" !important;
  }

  :global(.el-table__expand-icon--expanded i) {
    transform: rotate(180deg);
  }
}



</style>
